import { useEffect,useState,useContext,useRef } from 'react';
import { useSearchParams } from 'react-router-dom'
import { useEntityCrud } from '../../hooks/useEntityCrud';
import { Context } from '../../context/UserContext';
import { toast } from 'react-toastify';
import { NumericFormat } from 'react-number-format';
import ReactSelect from 'react-select';
import AvatarEditor from 'react-avatar-editor';
import InputRange from 'react-input-range';
import * as Yup from 'yup'
import { useFormik } from 'formik';
import Input from '../Common/Input';

const Index = () => {

    const context = useContext(Context);
    const [searchParams] = useSearchParams();

    const { readDataByFilter: readDataGroup } = useEntityCrud('Group/GetAllGroups');
    const { addData: addGroup } = useEntityCrud('Group/SetGroup');
    const { addData: updateGroup } = useEntityCrud('Group/UpdateGroup');
    const { addData: getBusinesses } = useEntityCrud('Business/GetAllBusiness');
    const [businesses,setBusinesses] = useState([]);
    const [businessId,setBusinessId] = useState(0);
    const [groups,setGroups] = useState([]);
    const [currentGroup,setCurrentGroup] = useState({})
    const [showGroupCollapse,setShowGroupCollapse] = useState(false);
    const { readDataByFilter: readDataService } = useEntityCrud('Service/GetAllBusinessServices');
    const { addData: addService } = useEntityCrud('Service/SetService');
    const { addData: updateService } = useEntityCrud('Service/UpdateService');
    const [services,setServices] = useState([]);
    const [currentService,setCurrentService] = useState({});
    const [showServiceCollapse,setShowServiceCollapse] = useState(false);
    const { readDataByFilter: readDataSubService } = useEntityCrud('SubService/GetSubservices');
    const { addData: addSubService } = useEntityCrud('SubService/SetSubService');
    const { addData: updateSubService } = useEntityCrud('SubService/UpdateSubService');
    const { addData: addSubServicePriceRequest } = useEntityCrud('PriceRequest/setPriceRequests');
    const { addData: addSubServiceImage } = useEntityCrud('SubService/SetSubServiceImage');
    const { addData: addSubServiceCount } = useEntityCrud('SubService/setsubServiceStock');
    const { addData: addSubServiceDiscountCode } = useEntityCrud('SubService/SetDiscountCodes');
    const [currentSubService,setCurrentSubService] = useState({});
    const [currentSubServiceId,setCurrentSubServiceId] = useState(0);
    const { addData: getSubServiceDiscountCode } = useEntityCrud(`SubService/GetDiscountCodes?subServiceId=${currentSubServiceId}`);
    const [subServices,setSubServices] = useState([]);
    const [showSubServiceCollapse,setShowSubServiceCollapse] = useState(false);
    const [templates,setTemplates] = useState([]);
    const [currentTemplate,setCurrentTemplate] = useState({fields: [{}],serviceId: ''});
    const [showTemplateeCollapse,setShowTemplateCollapse] = useState(false);
    const [showIsDicountCard,setShowIsDicountCard] = useState(false);
    const [list,setList] = useState([]);
    const [downloadList,setDownloadList] = useState([]);
    const [listUpdateStatus,setListUpdateStatus] = useState(1);
    const { readData: readDataTemplate } = useEntityCrud(`Template/GetAllTemplates?serviceId=${currentService.id}`);
    const { addData: addTemplate } = useEntityCrud('Template/SetTemplate');
    const { addData: updateTemplate } = useEntityCrud('Template/UpdateTemplate');
    const [oldSubServicePrice,setOldServicePrice] = useState()
    const { addData: getProductGroup } = useEntityCrud('Config/GetProductGroups');
    const { addData: addProductGroup } = useEntityCrud('Config/SetProductGroup');
    const { addData: updateProductGroup } = useEntityCrud('Config/UpdateProductGroup');
    const [productsGroups,setProductsGroups] = useState([]);

    const editor = useRef();
    const [imageSrc,setImageSrc] = useState('');
    const [zoom,setZoom] = useState(1.5);
    const [width,setWidth] = useState(0);
    const [height,setHeight] = useState(0);
    const [radius,setRadius] = useState(0);

    const roleId = localStorage.getItem('rl');

    const getProductsGroups = () => {
        getProductGroup({}).then(({ data }) => {
            if(data.status)
                setProductsGroups(data.result)
        });
    }

    useEffect(() => {
        if(roleId == 1){
            const postedData = {
                offset: 0,
                limit: 5000
            }
            const businessesData = [];
            getBusinesses(postedData).then(({data}) => {
                if(data.status){
                    data.result.map(item => {
                        businessesData.push({
                            value: item.id,
                            label: item.title
                        })
                    })
                    setBusinesses(businessesData)
                }
            })
            getProductsGroups()
        }
    },[])

    useEffect(() => {
        setBusinessId(searchParams.get('businessId'));
    },[searchParams])

    const getGroups = () => {
        const postedData = {
            buisnessId: businessId || context.businessId
        };
        readDataGroup(postedData).then(({data}) => {
            if(data.status)
                setGroups(data.result)
        })
    }
    
    const getServices = () => {
        const postedData = {
            businessId: businessId || context.businessId
        };
        readDataService(postedData).then(({data}) => {
            if(data.status)
                setServices(data.result)
        })
    }
    
    const getSubServices = () => {
        const postedData = {
            businessId: businessId || context.businessId
        };
        readDataSubService(postedData).then(({data}) => {
            if(data.status)
                setSubServices(data.result)
        })
    }
    
    const getTemplates = () => {
        if(currentService.id){
            readDataTemplate().then(({data}) => {
                if(data.status){
                    const oldTemplates = data.result;
                    const newTemplates = oldTemplates.map(item => {
                        return {
                            ...item,
                            fields: JSON.parse(item.fields)
                        }
                    });
                    setTemplates(newTemplates);
                }else
                    setTemplates([]);
            })
        }else
            setTemplates([]);
    }

    useEffect(() => {
        getGroups();
        getServices();
        getSubServices();
        setCurrentGroup({});
        setCurrentService({});
        setCurrentSubService({});
        setShowGroupCollapse(false);
        setShowServiceCollapse(false);
        setShowSubServiceCollapse(false);
        setShowTemplateCollapse(false);
        setList([]);
    },[context.businessId,businessId])

    useEffect(() => {
        getTemplates();
    },[currentService]);

    const saveGroup = () => {
        if(currentGroup.id){
            updateGroup(currentGroup).then(({data}) => {
                if(data.status){
                    getGroups();
                    toast.success('گروه مورد نظر با موفقیت به روزرسانی شد');
                    setCurrentGroup({});
                    setShowGroupCollapse(false);
                }
            })
        }else{
            currentGroup.businessId = businessId || context.businessId;
            addGroup(currentGroup).then(({data}) => {
                if(data.status){
                    getGroups();
                    toast.success('گروه جدید با موفقیت افزوده شد');
                    setCurrentGroup({});
                    setShowGroupCollapse(false);
                }
            })
        }
    }

    const saveService = () => {
        if(currentService.id){
            updateService(currentService).then(({data}) => {
                if(data.status){
                    getServices();
                    toast.success('سرویس مورد نظر با موفقیت به روزرسانی شد');
                    setCurrentService({});
                    setShowServiceCollapse(false);
                }
            })
        }else{
            addService(currentService).then(({data}) => {
                if(data.status){
                    getServices();
                    toast.success('سرویس جدید با موفقیت افزوده شد');
                    setCurrentService({});
                    setShowServiceCollapse(false);
                }
            });
        }
    }

    const saveSubService = () => {
        currentSubService.price = parseInt(currentSubService.price.toString().replace(/,/g,''));
        currentSubService.stockMode = parseInt(currentSubService.stockMode);
        currentSubService.stockQuantity = parseInt(currentSubService.stockQuantity);
        if(currentSubService.id){
            if(currentSubService.price != oldSubServicePrice){
                const postedData = {
                    subServicesId: currentSubService.id,
                    price: oldSubServicePrice
                }
                addSubServicePriceRequest(postedData);
            }
            updateSubService(currentSubService).then(({data}) => {
                if(data.status){
                    toast.success('محصول / خدمت مورد نظر با موفقیت به روزرسانی شد');
                    if(list != '')
                        updateDiscountCodes()
                    setShowSubServiceCollapse(false);
                    if(currentSubService.image){
                        const imagePostedData = {
                            imageContent: currentSubService.image.split('base64,')[1],
                            subserviceId: currentSubService.id
                        };
                        addSubServiceImage(imagePostedData)
                    }
                    const stockPostedData = {
                        subServiceId: currentSubService.id,
                        stockMode: parseInt(currentSubService.stockMode),
                        quantity: parseInt(currentSubService.stockQuantity)
                    }
                    addSubServiceCount(stockPostedData)
                    setTimeout(() => {
                        getSubServices();
                    },500)
                }
            })
        }else{
            addSubService(currentSubService).then(({data}) => {
                if(data.status){
                    toast.success('محصول / خدمت جدید با موفقیت افزوده شد');
                    if(list.length)
                        updateDiscountCodes()
                    setShowSubServiceCollapse(false);
                    if(currentSubService.image){
                        const imagePostedData = {
                            imageContent: currentSubService.image.split('base64,')[1],
                            subserviceId: currentSubService.id
                        };
                        addSubServiceImage(imagePostedData)
                    }
                    const stockPostedData = {
                        subServiceId: currentSubService.id,
                        stockMode: parseInt(currentSubService.stockMode),
                        quantity: parseInt(currentSubService.stockQuantity)
                    }
                    addSubServiceCount(stockPostedData)
                    setTimeout(() => {
                        getSubServices();
                    },500)
                }
            });
        }
    }

    const toBase64 = async file => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    }

    const setFile = async e => {
        const file = e.target.files[0];
        const finalFile = await toBase64(file);
        setCurrentSubService({...currentSubService,image: finalFile})
    }

    const addTemplateFieldRow = () => {
        const oldTemplate = {...currentTemplate};
        oldTemplate.fields.push({});
        setCurrentTemplate(oldTemplate)
    }

    const removeTemplateFieldRow = index => {
        const oldTemplate = {...currentTemplate};
        oldTemplate.fields.splice(index,1);
        setCurrentTemplate(oldTemplate)
    }

    const setCurrentTemplateFieldTitle = (index,value) => {
        const oldTemplate = {...currentTemplate};
        oldTemplate.fields[index].title = value;
        setCurrentTemplate(oldTemplate)
    }

    const setCurrentTemplateFieldType = (index,value) => {
        const oldTemplate = {...currentTemplate};
        oldTemplate.fields[index].type = value;
        setCurrentTemplate(oldTemplate)
    }

    const saveTemplate = () => {
        const posteData = {
            ...currentTemplate,
            serviceTitle: '',
            fields: JSON.stringify(currentTemplate.fields)
        }
        if(currentTemplate.id){
            updateTemplate(posteData).then(({data}) => {
                if(data.status){
                    getTemplates();
                    toast.success('قالب مورد نظر با موفقیت به روزرسانی شد');
                    setCurrentTemplate({fields: [{}],serviceId: ''});
                    setShowTemplateCollapse(false);
                }
            })
        }else{
            addTemplate(posteData).then(({data}) => {
                if(data.status){
                    getTemplates();
                    toast.success('قالب جدید با موفقیت افزوده شد');
                    setCurrentTemplate({fields: [{}],serviceId: ''});
                    setShowTemplateCollapse(false);
                }
            })
        }
    }

    const setCurrentFile = async e => {
        const file = e.target.files[0];
        const fileData = await toBase64(file);
        setWidth(240)
        setHeight(240)
        setRadius(0)
        setImageSrc(fileData);
    }

    const downloadImageCropped = () => {
        if(editor){
            const imageData = editor.current.getImageScaledToCanvas().toDataURL('image/jpeg');
            setCurrentSubService({...currentSubService,image: imageData})
            setTimeout(() => {
                setImageSrc('');
                setZoom(1.5);
                setRadius(0);
                document.getElementById('modal-file-input').value = '';
            }, 300)
        }
    }

    const downloadImage = base64 => {
        let image = new Image();
        image.src = base64;
        let newWindow = window.open('');
        newWindow.document.write(image.outerHTML);
    }

    const openUploadedImage = url => window.open(`https://petromah.sabinarya.com/${url}`)

    const handleDiscountFile = async e => {
        const file = e.target.files[0];
        const fileData = await toBase64(file);
        setList(fileData);
    }

    const updateDiscountCodes = () => {
        const postedData = {
            subServiceId: currentSubService.id,
            status: listUpdateStatus,
            file: list
        }
        addSubServiceDiscountCode(postedData).then(({data}) => {
            if(data.status){
                toast.success('به روزرسانی لیست کد های تخفیف با موفقیت انجام شد')
                setList([])
            }else
                data.errors.map(error => toast.error(error.message))
        })
    }

    useEffect(() => {
        setList([])
        if(currentSubService)
            setCurrentSubServiceId(currentSubService.id)
    },[currentSubService])

    useEffect(() => {
        getSubServiceDiscountCode().then(({data}) => {
            if(data.status && data.result.length){
                setDownloadList(data.result)
                setShowIsDicountCard(true)
            }
        })
    },[currentSubServiceId])

    const downloadDiscountCodeList = () => {
        const codeListStr = downloadList.join('\r\n');
        const csvContent = 'data:text/csv;charset=utf-8,' + codeListStr;
        var encodedUri = encodeURI(csvContent);
        var link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        link.setAttribute("download", "discount-code-list.csv");
        document.body.appendChild(link);
        link.click(); 
    }

    const handleFromDateChange = e => {
        const formattedDate = `${e.year}/${e.month > 9 ? e.month : ('0' + e.month)}/${e.day > 9 ? e.day : ('0' + e.day)}`
        setCurrentSubService({...currentSubService,specialFromDateValue: e,specialFromDate: formattedDate})
    }

    const handleToDateChange = e => {
        const formattedDate = `${e.year}/${e.month > 9 ? e.month : ('0' + e.month)}/${e.day > 9 ? e.day : ('0' + e.day)}`
        setCurrentSubService({...currentSubService,specialtoDateValue: e,specialtoDate: formattedDate})
    }

    const handleOldPrice = subService => {
        if(subService != null){
            const oldSubService = JSON.parse(JSON.stringify(subService))
            setOldServicePrice(oldSubService.price)
        }
    }

    const initialValues = {
        title: '',
        isActive: 1
    }

    const validationSchema = Yup.object({
        title: Yup.string().required()
    })

    const onSubmit = values => {
        const postedData = {
            ...values,
            isActive: values.isActive == 1
        }
        if(values.id){
            updateProductGroup(postedData).then(({ data }) => {
                if(data.status){
                    toast.success('اطلاعات با موفقیت ذخیره شد');
                    document.getElementById('close-modal-btn').click();
                    getProductsGroups();
                    formik.setValues({...initialValues})
                }
            })
        }else{
            addProductGroup(postedData).then(({ data }) => {
                if(data.status){
                    toast.success('اطلاعات با موفقیت ذخیره شد');
                    document.getElementById('close-modal-btn').click();
                    getProductsGroups();
                    formik.setValues({...initialValues})
                }
            })
        }
    }

    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit
    })
    
    return (
        <>
        <div className="card">
            <div className="card-header">
                <div className="card-title">مدیریت محصولات / خدمات</div>
            </div>
            <div className="card-body">
                <div className="modal fade" id="uploadImage" tabindex="-1" aria-labelledby="uploadImageLabel" aria-hidden="true">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h1 className="modal-title fs-5" id="uploadImageLabel">بارگذاری تصویر</h1>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"><i className="fa fa-close"></i></button>
                            </div>
                            <div className="modal-body text-center">
                                <div className={`row ${imageSrc ? 'mb-2' : ''}`}>
                                    <div className="col-md-6">
                                        <div className="form-group text-start">
                                            <label>انتخاب تصویر</label>
                                            <input type="file" id="modal-file-input" className="form-control" accept="image/jpeg,image/png" onChange={e => setCurrentFile(e)} />
                                        </div>
                                    </div>
                                </div>
                                {!!imageSrc && <>
                                    <AvatarEditor ref={editor} image={imageSrc} width={width} height={height} border={20} color={[255, 255, 255, 0.5]} scale={zoom} rotate={0} borderRadius={radius} />
                                    <p className="mt-3 text-start">زوم</p>
                                    <div dir="ltr" className="mt-1 mb-4"><InputRange maxValue={10} step={0.5} minValue={1} value={zoom} onChange={value => setZoom(value)} /></div>
                                </>}
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-danger" data-bs-dismiss="modal">لغو</button>
                                {!!imageSrc && <button type="button" className="btn btn-primary" onClick={downloadImageCropped} data-bs-dismiss="modal">بارگذاری تصویر</button>}
                            </div>
                        </div>
                    </div>
                </div>
                {roleId == 1 ? <div className="custom-box-container mb-5">
                    <h5><b>کسب و کار ها</b></h5>
                    <hr />
                    <div className="row justify-content-between mb-3">
                        <div className="col-md-3">
                            <div className="form-group">
                                <label>کسب و کار</label>
                                <ReactSelect value={businesses.filter(b => b.value == businessId)} onChange={e => setBusinessId(e.value)} options={businesses} placeholder="انتخاب کنید" />
                            </div>
                        </div>
                    </div>
                </div> : ''}
                <div className="custom-box-container mb-5">
                    <h5><b>گروه ها</b></h5>
                    <hr />
                    <div className="row justify-content-between mb-3">
                        <div className="col-md-11">
                            {groups.map((group,index) => <button key={`gp-${index}`} className="btn btn-primary mb-2 me-2" onClick={e => {setShowGroupCollapse(true);setCurrentGroup(group);setShowServiceCollapse(false);setShowSubServiceCollapse(false);setCurrentService({})}}>{group.title}</button>)}
                        </div>
                        <div className="col-md-1">
                            <button className="btn btn-success w-100" onClick={e => {setShowGroupCollapse(true);setCurrentGroup({});setShowServiceCollapse(false);setShowSubServiceCollapse(false);setCurrentService({})}}>افزودن</button>
                        </div>
                    </div>
                    <div className={`collapse ${showGroupCollapse ? 'show' : ''}`} id="group-collapse">
                        <div style={{border: '1px solid #c1c1c1',borderRadius: 5,boxShadow: 'unset',padding: 15}}>
                            <div className="row">
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label>عنوان</label>
                                        <input className="form-control" value={currentGroup.title || ''} onChange={e => setCurrentGroup({...currentGroup,title: e.target.value})} />
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label>وضعیت</label>
                                        <select className="form-control" onChange={e => setCurrentGroup({...currentGroup,isActive: e.target.value == 1})}>
                                            <option value={1} selected={currentGroup.isActive}>فعال</option>
                                            <option value={0} selected={!currentGroup.isActive}>غیرفعال</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label>نوع</label>
                                        <select className="form-control" onChange={e => setCurrentGroup({...currentGroup,nature: e.target.value})}>
                                            <option value={1} selected={currentGroup.nature == 1}>محصول / کالا</option>
                                            <option value={2} selected={currentGroup.nature == 2}>خدمت</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <button className="btn btn-success me-2" style={{marginTop: 30}} onClick={saveGroup}>{currentGroup.id ? 'ذخیره تغییرات' : 'افزودن گروه'}</button>
                                    <button className="btn btn-danger" style={{marginTop: 30}} onClick={() => setShowGroupCollapse(false)}>لغو</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="custom-box-container mb-5">
                    <h5><b>سرویس ها</b></h5>
                    <hr />
                    <div className="row justify-content-between mb-3">
                        <div className="col-md-11">
                            {services.filter(service => service.groupId == currentGroup.id).length ? services.filter(service => service.groupId == currentGroup.id).map((service,index) => <button key={`se-${index}`} className="btn btn-warning mb-2 me-2" onClick={e => {setShowServiceCollapse(true);setCurrentService(service);setShowSubServiceCollapse(false)}}>{service.title}</button>) : <div className="alert alert-info mb-0"><p className="mb-0">جهت نمایش سرویس ها باید گروهی را انتخاب کنید</p></div>}
                        </div>
                        <div className="col-md-1">
                            <button className="btn btn-success w-100" onClick={e => {setShowServiceCollapse(true);setCurrentService({...{},groupId: currentService.groupId ?? currentGroup.id});setShowSubServiceCollapse(false)}}>افزودن</button>
                        </div>
                    </div>
                    <div className={`collapse ${showServiceCollapse ? 'show' : ''}`} id="service-collapse">
                        <div style={{border: '1px solid #c1c1c1',borderRadius: 5,boxShadow: 'unset',padding: 15}}>
                            <div className="row">
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label>گروه</label>
                                        <select className="form-control" onChange={e => setCurrentService({...currentService,groupId: parseInt(e.target.value)})}>
                                            <option>انتخاب کنید</option>
                                            {groups.map(group => <option key={`select-group-${group.id}`} selected={group.id == currentService.groupId} value={group.id}>{group.title}</option>)}
                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label>عنوان</label>
                                        <input className="form-control" value={currentService.title || ''} onChange={e => setCurrentService({...currentService,title: e.target.value})} />
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label>روش ارسال</label>
                                        <select className="form-control" onChange={e => setCurrentService({...currentService,deliverType: parseInt(e.target.value)})}>
                                            <option>انتخاب کنید</option>
                                            <option value="1" selected={currentService.deliverType == 1}>دریافت حضوری</option>
                                            <option value="2" selected={currentService.deliverType == 2}>ارسال با پیک</option>
                                            <option value="3" selected={currentService.deliverType == 3}>هر دو</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label>وضعیت</label>
                                        <select className="form-control" onChange={e => setCurrentService({...currentService,isActive: parseInt(e.target.value)})}>
                                            <option>انتخاب کنید</option>
                                            <option value={1} selected={currentService.isActive}>فعال</option>
                                            <option value={0} selected={!currentService.isActive}>غیرفعال</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <button className="btn btn-success me-2" onClick={saveService}>{currentService.id ? 'ذخیره تغییرات' : 'افزودن سرویس'}</button>
                                    <button className="btn btn-danger" onClick={() => setShowServiceCollapse(false)}>لغو</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="custom-box-container mb-5">
                    <h5><b>محصولات / خدمات</b></h5>
                    <hr />
                    <div className="row justify-content-between mb-3">
                        <div className="col-md-11">
                            {subServices.filter(subService => subService.serviceId == currentService.id).length ? subServices.filter(subService => subService.serviceId == currentService.id).map((subService,index) => <button key={`ss-${index}`} className="btn btn-secondary mb-2 me-2" onClick={e => {setShowSubServiceCollapse(true);setCurrentSubService(subService);handleOldPrice(subService)}}>{subService.title}</button>) : <div className="alert alert-info mb-0"><p className="mb-0">جهت نمایش محصولات / خدمات باید سرویسی را انتخاب کنید</p></div>}
                        </div>
                        <div className="col-md-1">
                            <button className="btn btn-success w-100" onClick={e => {setShowSubServiceCollapse(true);setCurrentSubService({...{},groupId: currentSubService.groupId ?? currentGroup.id,serviceId: currentSubService.serviceId ?? currentService.id});handleOldPrice(null)}}>افزودن</button>
                        </div>
                    </div>
                    <div className={`collapse ${showSubServiceCollapse ? 'show' : ''}`} id="service-collapse">
                        <div style={{border: '1px solid #c1c1c1',borderRadius: 5,boxShadow: 'unset',padding: 15}}>
                            <div className="row">
                                {!currentSubService.id ? <div className="col-md-3">
                                    <div className="form-group">
                                        <label>گروه</label>
                                        <select className="form-control" onChange={e => setCurrentSubService({...currentSubService,groupId: parseInt(e.target.value)})}>
                                            <option>انتخاب کنید</option>
                                            {groups.map(group => <option key={`select-sub-group-${group.id}`} selected={group.id == currentSubService.groupId} value={group.id}>{group.title}</option>)}
                                        </select>
                                    </div>
                                </div> : ''}
                                {!currentSubService.id ? <div className="col-md-3">
                                    <div className="form-group">
                                        <label>سرویس</label>
                                        <select className="form-control" onChange={e => setCurrentSubService({...currentSubService,serviceId: parseInt(e.target.value)})}>
                                            <option>انتخاب کنید</option>
                                            {services.filter(service => service.groupId == currentSubService.groupId).map(service => <option key={`select-sub-service-${service.id}`} selected={service.id == currentSubService.serviceId} value={service.id}>{service.title}</option>)}
                                        </select>
                                    </div>
                                </div> : ''}
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label>گروه بندی داخل سازمانی</label>
                                        <select className="form-control" onChange={e => setCurrentSubService({...currentSubService,productGroupId: parseInt(e.target.value)})}>
                                            <option>انتخاب کنید</option>
                                            {productsGroups.map(productGroup => <option key={`select-group-product-${productGroup.id}`} selected={productGroup.id == currentSubService.productGroupId} value={productGroup.id}>{productGroup.title}</option>)}
                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label>عنوان</label>
                                        <input className="form-control" value={currentSubService.title || ''} onChange={e => setCurrentSubService({...currentSubService,title: e.target.value})} />
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label>قیمت (ریال)</label>
                                        <NumericFormat
                                            className="form-control"
                                            required={true}
                                            value={currentSubService.price || ''}
                                            onChange={e => setCurrentSubService({...currentSubService,price: e.target.value})}
                                            isRtl={true}
                                            dir="ltr"
                                            thousandSeparator=","
                                            allowNegative={false}
                                        />
                                    </div>
                                </div>
                                <div className={currentSubService.id ? 'col-md-6' : 'col-md-12'}>
                                    <div className="form-group">
                                        <label>توضیحات</label>
                                        <input className="form-control" value={currentSubService.description || ''} onChange={e => setCurrentSubService({...currentSubService,description: e.target.value})} />
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="form-group">
                                        <label>قوانین</label>
                                        <textarea className="form-control" rows={3} value={currentSubService.rules || ''} onChange={e => setCurrentSubService({...currentSubService,rules: e.target.value})} />
                                    </div>
                                </div>
                                {/* <div className="col-12">
                                    <div className="row">
                                        <div className="col-md-2">
                                            <label>قیمت ویژه</label>
                                            <NumericFormat
                                                className="form-control ltr-input"
                                                value={currentSubService.specialPrice}
                                                onChange={e => setCurrentSubService({...currentSubService,specialPrice: e.target.value})}
                                                isRtl={true}
                                                dir="ltr"
                                                thousandSeparator=","
                                                allowNegative={false}
                                            />
                                        </div>
                                        <div className="col-md-2">
                                            <div className="form-group">
                                                <label>از تاریخ</label>
                                                {currentSubService.specialFromDateValue && <i class="fe fe-x clear-select-btn" onClick={() => setCurrentSubService({...currentSubService,specialFromDateValue: null})} style={{left: 25}}></i>}
                                                <DatePicker
                                                    locale="fa"
                                                    inputClassName="form-control"
                                                    shouldHighlightWeekends
                                                    value={currentSubService.specialFromDateValue}
                                                    onChange={e => handleFromDateChange(e)}
                                                    className="form-control"
                                                    inputPlaceholder=' تاریخ  را انتخاب کنید ...'
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-2">
                                            <div className="form-group">
                                                <label>از ساعت</label>
                                                <InputMask mask="99:99" className="form-control ltr-input" style={{ height: 38.2 }} value={currentSubService.specialFromTime} onChange={e => setCurrentSubService({...currentSubService,specialFromTime: e.target.value})} />
                                            </div>
                                        </div>
                                        <div className="col-md-2">
                                            <div className="form-group">
                                                <label>تا تاریخ</label>
                                                {currentSubService.specialtoDateValue && <i class="fe fe-x clear-select-btn" onClick={() => setCurrentSubService({...currentSubService,specialtoDateValue: null})} style={{left: 25}}></i>}
                                                <DatePicker
                                                    locale="fa"
                                                    inputClassName="form-control"
                                                    shouldHighlightWeekends
                                                    value={currentSubService.specialtoDateValue}
                                                    onChange={e => handleToDateChange(e)}
                                                    className="form-control"
                                                    inputPlaceholder=' تاریخ  را انتخاب کنید ...'
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-2">
                                            <div className="form-group">
                                                <label>تا ساعت</label>
                                                <InputMask mask="99:99" className="form-control ltr-input" style={{ height: 38.2 }} value={currentSubService.specialtoTime} onChange={e => setCurrentSubService({...currentSubService,specialtoTime: e.target.value})} />
                                            </div>
                                        </div>
                                        <div className="col-md-2">
                                            <div className="form-group">
                                                <label>تعداد</label>
                                                <NumericFormat
                                                    className="form-control ltr-input"
                                                    value={currentSubService.specialQuantity}
                                                    onChange={e => setCurrentSubService({...currentSubService,specialQuantity: e.target.value})}
                                                    isRtl={true}
                                                    dir="ltr"
                                                    allowNegative={false}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div> */}
                                <div className="col-md-3">
                                    {currentSubService.image ? <small className="text-primary" style={{ float: 'left',marginBottom: -17 }} onClick={() => downloadImage(currentSubService.image)}>مشاهده تصویر</small> : ''}
                                    {currentSubService.imagePath && !currentSubService.image ? <small className="text-primary" style={{ float: 'left',marginBottom: -17 }} onClick={() => openUploadedImage(currentSubService.imagePath)}>مشاهده تصویر</small> : ''}
                                    <button type="button" className="btn btn-primary w-100 mb-3" style={{marginTop: currentSubService.image ? 12 : 29}} data-bs-toggle="modal" data-bs-target="#uploadImage">بارگذاری آیکون</button>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label>نوع موجودی</label>
                                        <select className="form-control" onChange={e => setCurrentSubService({...currentSubService,stockMode: e.target.value})}>
                                            <option>انتخاب کنید</option>
                                            <option value="1" selected={currentSubService.stockMode == 1}>چند ساعتی (هر سه ساعت)</option>
                                            <option value="2" selected={currentSubService.stockMode == 2}>روزانه</option>
                                            <option value="3" selected={currentSubService.stockMode == 3}>ثابت</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <label>میزان موجودی</label>
                                    <input className="form-control" value={currentSubService.stockQuantity || ''} onChange={e => setCurrentSubService({...currentSubService,stockQuantity: e.target.value})} />
                                </div>
                                <div className="col-md-1">
                                    <div className="form-group">
                                        <label>وضعیت</label>
                                        <select className="form-control" onChange={e => setCurrentSubService({...currentSubService,isActive: parseInt(e.target.value)})}>
                                            <option>انتخاب کنید</option>
                                            <option value={1} selected={currentSubService.isActive}>فعال</option>
                                            <option value={0} selected={!currentSubService.isActive}>غیرفعال</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-2">
                                    <div className="form-group">
                                        <label>محصول کارت تخفیف ؟</label>
                                        <select className="form-control" onChange={() => setShowIsDicountCard(!showIsDicountCard)} value={showIsDicountCard}>
                                            <option>انتخاب کنید</option>
                                            <option value={false}>خیر</option>
                                            <option value={true}>بله</option>
                                        </select>
                                    </div>
                                </div>
                                {showIsDicountCard && <>
                                    <div className="col-10">
                                        <div className="form-group">
                                            <label>بارگذاری فایل کد های تخفیف</label>
                                            <input className="form-control" type="file" onChange={handleDiscountFile} />
                                        </div>
                                    </div>
                                    <div className="col-2">
                                        <div className="form-group">
                                            <label>وضعیت کد های تخفیف</label>
                                            <select className="form-control" onChange={() => setListUpdateStatus(listUpdateStatus == 1 ? 0 : 1)} value={listUpdateStatus}>
                                                <option>انتخاب کنید</option>
                                                <option value={1}>درج اولیه</option>
                                                <option value={0}>غیرفعال سازی</option>
                                            </select>
                                        </div>
                                    </div>
                                </>}
                                <div className="col-md-12">
                                    <button className="btn btn-success me-2" onClick={saveSubService}>{currentSubService.id ? 'ذخیره تغییرات' : 'افزودن محصول / خدمت'}</button>
                                    <button className="btn btn-danger me-2" onClick={() => setShowSubServiceCollapse(false)}>لغو</button>
                                    {!!downloadList.length && <button className="btn btn-primary" onClick={downloadDiscountCodeList}>دانلود لیست کد های تخفیف</button>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="custom-box-container">
                    <h5><b>قالب ها</b></h5>
                    <hr />
                    <div className="row justify-content-between mb-3">
                        <div className="col-md-11">
                            {templates.filter(tmpl => tmpl.serviceId == currentService.id).length ? templates.filter(tmpl => tmpl.serviceId == currentService.id).map((tmpl,index) => <button key={`tt-${index}`} className="btn btn-dark mb-2 me-2" onClick={e => {setShowTemplateCollapse(true);setCurrentTemplate(tmpl)}}>{tmpl.serviceTitle}</button>) : <div className="alert alert-info mb-0"><p className="mb-0">جهت نمایش قالب ها باید سرویسی را انتخاب کنید</p></div>}
                        </div>
                        <div className="col-md-1">
                            <button className="btn btn-success w-100" onClick={e => {setShowTemplateCollapse(true);setCurrentTemplate({fields: [{}],serviceId: ''})}}>افزودن</button>
                        </div>
                    </div>
                    <div className={`collapse ${showTemplateeCollapse ? 'show' : ''}`} id="template-collapse">
                        <div style={{border: '1px solid #c1c1c1',borderRadius: 5,boxShadow: 'unset',padding: 15}}>
                            <div className="row">
                                {!currentTemplate.id ? <div className="col-md-2">
                                    <div className="form-group">
                                        <label>گروه</label>
                                        <select className="form-control" onChange={e => setCurrentTemplate({...currentTemplate,groupId: parseInt(e.target.value)})}>
                                            <option>انتخاب کنید</option>
                                            {groups.map(group => <option key={`select-sub-group-${group.id}`} selected={group.id == currentTemplate.groupId} value={group.id}>{group.title}</option>)}
                                        </select>
                                    </div>
                                </div> : ''}
                                {!currentTemplate.id ? <div className="col-md-2">
                                    <div className="form-group">
                                        <label>سرویس</label>
                                        <select className="form-control" onChange={e => setCurrentTemplate({...currentTemplate,serviceId: parseInt(e.target.value)})}>
                                            <option>انتخاب کنید</option>
                                            {services.map(service => <option key={`select-sub-service-${service.id}`} selected={service.id == currentTemplate.serviceId} value={service.id}>{service.title}</option>)}
                                        </select>
                                    </div>
                                </div> : ''}
                            </div>
                            <h6><b>فیلد های درخواستی</b></h6>
                            {currentTemplate.fields.map((field,index) => <div className="row" key={`template-${index}`}>
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label>عنوان</label>
                                        <input className="form-control" onChange={e => setCurrentTemplateFieldTitle(index,e.target.value)} value={field.title || ''} />
                                    </div>
                                </div>
                                <div className="col-md-2">
                                    <div className="form-group">
                                        <label>نوع</label>
                                        <select className="form-control" onChange={e => setCurrentTemplateFieldType(index,e.target.value)} value={field.type || ''}>
                                            <option>انتخاب کنید</option>
                                            <option value={0}>متن</option>
                                            <option value={1}>عدد</option>
                                            <option value={2}>تاریخ</option>
                                        </select>
                                    </div>
                                </div>
                                {index == 0 ? <div className="col-md-1">
                                    <button className="btn btn-icon btn-primary" style={{marginTop: 29}} onClick={addTemplateFieldRow}><i className="fa fa-plus"></i></button>
                                </div> : <div className="col-md-1">
                                    <button className="btn btn-icon btn-danger" style={{marginTop: 29}} onClick={() => removeTemplateFieldRow(index)}><i className="fa fa-minus"></i></button>
                                </div>}
                            </div>)}
                            <button className="btn btn-success me-2" style={{marginTop: 15}} onClick={saveTemplate}>{currentTemplate.id ? 'ذخیره تغییرات' : 'افزودن قالب'}</button>
                            <button className="btn btn-danger" style={{marginTop: 15}} onClick={() => setShowTemplateCollapse(false)}>لغو</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="card">
            <div className="card-header">
                <div className="card-title">گروه محصولات</div>
            </div>
            <div className="card-body">
                <button className="btn btn-primary mb-3" data-bs-toggle="modal" data-bs-target="#pg-modal" onClick={() => formik.setValues({...initialValues})}>ایجاد گروه محصول جدید</button>
                <div className="modal fade" id="pg-modal" tabindex="-1" aria-hidden="true">
                    <form className="modal-dialog" onSubmit={formik.handleSubmit}>
                        <div className="modal-content">
                            <div className="modal-header">
                                <h1 className="modal-title fs-5">{formik.values.id ? 'ایجاد گروه محصول' : 'ویرایش گروه محصول'}</h1>
                                <button type="button" id="close-modal-btn" className="btn-close" data-bs-dismiss="modal" aria-label="Close"><i className="fa fa-close"></i></button>
                            </div>
                            <div className="modal-body">
                                <div className="row">
                                    <div className={`col-md-${formik.values.id ? 6 : 12}`}>
                                        <Input formik={formik} label="عنوان" name="title" />
                                    </div>
                                    {!!formik.values.id && <div className="col-md-6">
                                        <div className="form-group">
                                            <label>وضعیت</label>
                                            <select className="form-control" onChange={e => formik.setFieldValue('isActive',e.target.value)} value={formik.values.isActive ? 1 : 0}>
                                                <option value="1">فعال</option>
                                                <option value="0">غیرفعال</option>
                                            </select>
                                        </div>
                                    </div>}
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-danger" data-bs-dismiss="modal">لغو</button>
                                <button className="btn btn-success px-5">ذخیره </button>
                            </div>
                        </div>
                    </form>
                </div>
                {productsGroups.length > 0 ? <div className="table-responsive">
                    <table className="table table-hover table-bordered">
                        <thead>
                            <tr>
                                <th>ردیف</th>
                                <th>عنوان</th>
                                <th>وضعیت</th>
                                <th>عملیات</th>
                            </tr>
                        </thead>
                        <tbody>
                            {productsGroups.map((item,index) => <tr key={index}>
                                <td>{++index}</td>
                                <td>{item.title}</td>
                                <td>{item.isActive ? <i className="fe fe-check text-success"></i> : <i className="fe fe-x text-danger"></i>}</td>
                                <td>
                                    <button className="btn btn-icon mb-0 btn-primary" data-bs-toggle="modal" data-bs-target="#pg-modal" onClick={() => formik.setValues({...item})}><i className="fe fe-edit-2"></i></button>
                                </td>
                            </tr>)}
                        </tbody>
                    </table>
                </div> : <div className="alert alert-info mb-0">
                    <p className="mb-0">گروه محصولی یافت نشد</p>
                </div>}
            </div>
        </div>
        </>
    )
}

export default Index;